import { render, staticRenderFns } from "./VerifyAccountOneOffTopUpBtn.vue?vue&type=template&id=6d3bdef7&scoped=true&"
import script from "./VerifyAccountOneOffTopUpBtn.vue?vue&type=script&lang=js&"
export * from "./VerifyAccountOneOffTopUpBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3bdef7",
  null
  
)

export default component.exports